import React, { useEffect, useState } from 'react'

import Loader from 'react-loader-spinner'

import './modal-viewer.scss'
import ModalLogin from '@/components/molecules/modal-login/modal-login'
import ModalDownload from '@/components/molecules/modal-download/modal-download'
import ModalSigned from '@/components/molecules/modal-signed/modal-signed'
type TModalProps = {
  id: string
  props: any
}
const ModalStore: {
  current: null | TModalProps
  update: (id: string, props: any) => void
  close: () => void
} = {
  current: null,
  update: (id: string, props: any) => {},
  close: () => {},
}
const Modals: Record<string, (props: any) => React.JSX.Element> = {
  login: ModalLogin,
  download: ModalDownload,
  signed: ModalSigned,
}
const WaitingModal = () => {
  return (
    <div>
      <Loader type="Oval" color="#ffffff" height={22} width={30} />
    </div>
  )
}
function getCurrentModalView() {
  if (!ModalStore.current) {
    return null
  }
  const modalId = ModalStore.current.id
  const modalProps = ModalStore.current.props
  const ModalComponent = Modals[modalId]
  if (!ModalComponent) return null

  return <ModalComponent {...modalProps} />
}

function injectProps(props: any = {}) {
  const temporal = {
    onClose: props.onClose,
  }
  props.onClose = function () {
    ModalStore.close()
    if (temporal.onClose) {
      temporal.onClose(...arguments)
    }
  }
  return props
}
export function callModal(idModal: string, props: any) {
  ModalStore.update(idModal, injectProps(props))
}

export default function ModalViewer() {
  const [dirty, setDirty] = useState(1)
  useEffect(() => {
    ModalStore.update = (id: string, props: any) => {
      ModalStore.current = { id, props }
      setDirty(dirty * -1)
    }
    ModalStore.close = () => {
      ModalStore.current = null
      setDirty(dirty * -1)
    }
  }, [dirty])

  if (!ModalStore.current) {
    return null
  }

  return (
    <React.Suspense fallback={<WaitingModal />}>
      <div className="f-modal-viewer">
        <div className="f-modal-viewer__card slide-in-bck-bottom ">
          <button
            className="btn-close icon2-close"
            onClick={() => {
              ModalStore.close()
            }}
          ></button>
          {getCurrentModalView()}
        </div>
      </div>
    </React.Suspense>
  )
}
